import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import StatusChip from './StatusChip';

// Depletion bar + In stock / Low stock / Out of stock badge — used in
// Inventory, product detail, and low-stock lists. `labels` carries the three
// already-translated badge strings; `unit` is the already-translated unit
// word (e.g. t('units')).
const StockLevel = ({ quantity, threshold = 10, max, unit, labels, sx }) => {
  const status = quantity <= 0 ? 'outOfStock' : quantity <= threshold ? 'lowStock' : 'inStock';
  const scale = max || Math.max(threshold * 4, quantity, 1);
  const pct = Math.min(100, Math.round((quantity / scale) * 100));

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, ...sx }}>
      <Box sx={{ flex: 1, minWidth: 56 }}>
        <LinearProgress
          variant="determinate"
          value={pct}
          color={status === 'inStock' ? 'success' : status === 'lowStock' ? 'warning' : 'error'}
        />
      </Box>
      {unit && (
        <Typography variant="body2" color="text.secondary" noWrap>
          {quantity} {unit}
        </Typography>
      )}
      {labels && <StatusChip status={status} label={labels[status]} />}
    </Box>
  );
};

export default StockLevel;
